// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.style__box--POFoy {
  border-radius: 1rem;
  background-color: #fff;
  margin: 1rem;
  padding: 1rem;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  height: 100%;
}
.style__hideOnOver--qrLtP:hover .style__examResultContainer--fmm6d {
  visibility: hidden;
}
.style__addExam--hBwZc {
  display: flex;
  align-items: center;
}
.style__addExam--hBwZc:hover div:first-of-type {
  display: none;
}
.style__addExam--hBwZc:hover div:last-of-type {
  display: flex;
}
.style__addExamLink--jmgU7 {
  display: none;
}
.style__examResultContainer--fmm6d {
  overflow: visible;
  display: flex;
}
.style__examResultContainerNoLicenseLeft--GIuzl {
  overflow: visible;
  display: flex;
}
.style__examResult--iTiiX {
  border-radius: 0.5rem;
  line-height: 1.6rem;
  text-align: center;
  display: flex;
  padding: 0 0.5rem;
}
.style__page--wIpF_ {
  overflow: hidden;
  display: flex;
  flex-direction: column;
  border-radius: 1rem;
  padding: 1rem;
}
.style__passedExam--FgRVR {
  color: #000;
  background: #f8f9ff;
}
.style__failedExam--tcqdB {
  color: #ff513d;
  background: #fff3f0;
}
.style__success--xL1wK {
  color: #00a751;
}
.style__cancel--SUTpa {
  color: #d72a1d;
}
.style__nowrap--mxVFO {
  white-space: nowrap;
}
.style__gridItem8--DMzVZ {
  flex: 0 0 14em !important;
}
.style__studentsGrid--L9IlM .gridItemSelector {
  cursor: pointer;
}
.style__studentsGrid--L9IlM .grid-row-hover {
  background-color: #e3e8e5 !important;
}
.style__tableArea--sYaoc {
  min-height: 12rem;
  display: flex;
  flex-direction: column;
}
`, "",{"version":3,"sources":["webpack://./../ds-admin/src/pages/StudentsPage/style.less"],"names":[],"mappings":"AAGA;EAEI,mBAAA;EACA,sBAAA;EACA,YAAA;EACA,aAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;AAHJ;AAOI;EAEI,kBAAA;AANR;AATA;EAqBI,aAAA;EACA,mBAAA;AATJ;AAWI;EAEI,aAAA;AAVR;AAQI;EAKI,aAAA;AAVR;AAnBA;EAmCI,aAAA;AAbJ;AAtBA;EAuCI,iBAAA;EACA,aAAA;AAdJ;AA1BA;EA4CI,iBAAA;EACA,aAAA;AAfJ;AA9BA;EAiDI,qBAAA;EACA,mBAAA;EACA,kBAAA;EACA,aAAA;EACA,iBAAA;AAhBJ;AArCA;EAyDI,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,aAAA;AAjBJ;AA5CA;EAiEI,WAAA;EACA,mBAAA;AAlBJ;AAhDA;EAsEI,cAAA;EACA,mBAAA;AAnBJ;AApDA;EA2EI,cAAA;AApBJ;AAvDA;EA+EI,cAAA;AArBJ;AA1DA;EAmFI,mBAAA;AAtBJ;AA7DA;EAuFM,yBAAA;AAvBN;AAhEA;EA4FM,eAAA;AAzBN;AAnEA;EAgGM,oCAAA;AA1BN;AAtEA;EAqGI,iBAAA;EACA,aAAA;EACA,sBAAA;AA5BJ","sourcesContent":["@import '@yaak/components/src/colors';\n@import '@yaak/components/src/spacing';\n\n:local {\n  .box {\n    border-radius: @spacing-100;\n    background-color: @color-white;\n    margin: @spacing-100;\n    padding: @spacing-100;\n    overflow: hidden;\n    display: flex;\n    flex-direction: column;\n    height: 100%;\n  }\n\n  .hideOnOver {\n    &:hover {\n      .examResultContainer {\n        visibility: hidden;\n      }\n    }\n  }\n\n  .addExam {\n    display: flex;\n    align-items: center;\n\n    &:hover {\n      div:first-of-type {\n        display: none;\n      }\n      div:last-of-type {\n        display: flex;\n      }\n    }\n  }\n\n  .addExamLink {\n    display: none;\n  }\n\n  .examResultContainer {\n    overflow: visible;\n    display: flex;\n  }\n\n  .examResultContainerNoLicenseLeft {\n    overflow: visible;\n    display: flex;\n  }\n\n  .examResult {\n    border-radius: @spacing-50;\n    line-height: 1.6rem;\n    text-align: center;\n    display: flex;\n    padding: 0 @spacing-50;\n  }\n\n  .page {\n    overflow: hidden;\n    display: flex;\n    flex-direction: column;\n    border-radius: @spacing-100;\n    padding: @spacing-100;\n  }\n\n  .passedExam {\n    color: @color-black;\n    background: @color-blue-099;\n  }\n\n  .failedExam {\n    color: @color-red-060;\n    background: @color-red-099;\n  }\n\n  .success {\n    color: @color-green-060;\n  }\n\n  .cancel {\n    color: @color-red-050;\n  }\n\n  .nowrap {\n    white-space: nowrap;\n  }\n\n  .gridItem8{\n      flex: 0 0 14em !important;\n  }\n\n  .studentsGrid {\n    :global(.gridItemSelector) {\n      cursor: pointer;\n    }\n\n    :global(.grid-row-hover) {\n      background-color: @color-pewter-grey-090 !important;\n    }\n  }\n\n  .tableArea {\n    min-height: 12rem;\n    display: flex;\n    flex-direction: column;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"box": `style__box--POFoy`,
	"hideOnOver": `style__hideOnOver--qrLtP`,
	"examResultContainer": `style__examResultContainer--fmm6d`,
	"addExam": `style__addExam--hBwZc`,
	"addExamLink": `style__addExamLink--jmgU7`,
	"examResultContainerNoLicenseLeft": `style__examResultContainerNoLicenseLeft--GIuzl`,
	"examResult": `style__examResult--iTiiX`,
	"page": `style__page--wIpF_`,
	"passedExam": `style__passedExam--FgRVR`,
	"failedExam": `style__failedExam--tcqdB`,
	"success": `style__success--xL1wK`,
	"cancel": `style__cancel--SUTpa`,
	"nowrap": `style__nowrap--mxVFO`,
	"gridItem8": `style__gridItem8--DMzVZ`,
	"studentsGrid": `style__studentsGrid--L9IlM`,
	"tableArea": `style__tableArea--sYaoc`
};
export default ___CSS_LOADER_EXPORT___;
